import { genericPost } from './apiService';
import { API_URL } from '../config/env';

/**
 * Kullanıcı girişi için login metodu.
 * @param {string} email - Kullanıcı e-postası
 * @param {string} password - Kullanıcı şifresi
 * @returns {Promise<Object>} - Sunucudan dönen yanıt
 */
export const login = async (email, password) => {
  try {
    const response = await genericPost(`${API_URL}Auth/authenticate`, {
      username: email,
      password,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Aktivasyon kodu doğrulama
 * @param {string} code - Aktivasyon kodu
 * @returns {Promise<Object>} - Sunucudan dönen yanıt
 */
export const activelogin = async (code) => {
  try {
    const response = await genericPost(`${API_URL}Auth/ActiveToken?code=${code}`, null);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Şifre sıfırlama e-postası gönderme
 * @param {string} email - Kullanıcı e-postası
 * @returns {Promise<Object>} - Sunucudan dönen yanıt
 */
export const forgetPassword = async (email) => {
  try {
    const response = await genericPost(`${API_URL}Auth/forgetPassword?email=${email}`, null);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Şifre sıfırlama kodu doğrulama
 * @param {Object} data - Şifre sıfırlama verileri
 * @returns {Promise<Object>} - Sunucudan dönen yanıt
 */
export const forgetPasswordCode = async (data) => {
  try {
    const response = await genericPost(`${API_URL}Auth/forgetPasswordCode`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Aktivasyon kodunu yenileme
 * @returns {Promise<Object>} - Sunucudan dönen yanıt
 */
export const coderefresh = async () => {
  try {
    const response = await genericPost(`${API_URL}Auth/codeRefresh`, null);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Kullanıcı kaydı
 * @param {Object} userData - Kayıt için gerekli kullanıcı bilgileri
 * @returns {Promise<Object>} - Sunucudan dönen yanıt
 */
export const register = async (userData) => {
  try {
    const response = await genericPost(`${API_URL}Auth/register`, userData);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Google/Facebook sosyal giriş
 */
export const socialLogin = async (provider, token) => {
  const response = await genericPost(`${API_URL}Auth/socialLogin`, {
    provider,
    token,
  });
  if (response?.data) {
    response.data.needsProfileCompletion =
      response.data.needsProfileCompletion ?? response.data.NeedsProfileCompletion ?? false;
    response.data.token = response.data.token ?? response.data.Token;
    response.data.email = response.data.email ?? response.data.Email;
    response.data.name = response.data.name ?? response.data.Name;
    response.data.lastName = response.data.lastName ?? response.data.LastName;
    response.data.id = response.data.id ?? response.data.Id;
  }
  if (response.statusCode === 200 && response.data?.token && !response.data.needsProfileCompletion) {
    localStorage.setItem('authToken', response.data.token);
  }
  return response;
};

/**
 * Sosyal kayıt için eksik profil tamamlama
 */
export const socialComplete = async (payload) => {
  const response = await genericPost(`${API_URL}Auth/socialComplete`, payload);
  if (response?.data) {
    response.data.token = response.data.token ?? response.data.Token;
    response.data.email = response.data.email ?? response.data.Email;
    response.data.name = response.data.name ?? response.data.Name;
    response.data.lastName = response.data.lastName ?? response.data.LastName;
    response.data.id = response.data.id ?? response.data.Id;
  }
  if (response.statusCode === 200 && response.data?.token) {
    localStorage.setItem('authToken', response.data.token);
  }
  return response;
};

/**
 * Çıkış yapma
 * @returns {Promise<Object>} - Sunucudan dönen yanıt
 */
export const logout = async () => {
  try {
    localStorage.removeItem('authToken');
    const response = await genericPost(`${API_URL}Auth/logout`, null);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Token yenileme
 * @param {string} refreshToken - Yenileme tokeni
 * @returns {Promise<Object>} - Sunucudan dönen yanıt
 */
export const refreshToken = async (refreshToken) => {
  try {
    const response = await genericPost(`${API_URL}Auth/RefreshToken`, {
      refreshToken
    });
    if (response.statusCode === 200) {
      localStorage.setItem('authToken', response.data.token);
    }
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Oturum kontrolü
 * @returns {Promise<Object>} - Sunucudan dönen yanıt
 */
export const checkAuth = async () => {
  try {
    const response = await genericPost(`${API_URL}Auth/CheckAuth`);
    return response;
  } catch (error) {
    throw error;
  }
};